export const LOADING_STATUS = {
  IDLE: 'idle',
  SUCCESS: 'success',
  PENDING: 'pending',
  REPENDING: 're-pending',
  ERROR: 'error',
} as const;
